import {ButtonPrimary} from '@homeaway/react-buttons';
import {COLLABORATE__24} from '../../../components/svg-def';
import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {withTranslationsAsProps} from '../../../components/translations';

export class InviteLogin extends Component {

    static defaultProps = {
        error: null,
        errorLogin: '',
        fetch: () => {},
        fullLocale: '',
        labelLogin: '',
        labelSignUp: '',
        loading: false,
        loginUrl: '',
        siteName: '',
        translations: {}
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {fetch, fullLocale, siteName} = this.props;
        fetch(fullLocale, siteName);
    }

    render() {
        const {desc, error, errorLogin, labelLogin, loginUrl, title} = this.props;
        const errorMsg = (error) ? errorLogin : null;

        return (
            <React.Fragment>
                <h5 className="flex-row">
                    <SVGIcon className="margin-right-1x" markup={COLLABORATE__24} />
                    {title}
                </h5>
                <p>{desc}</p>
                <div className="flex flex-align-items-center">
                    {/* supressing unless we can find the signup url
                    <Button
                        className="margin-right-1x"
                        href={signupUrl}
                        label={signup}
                    />
                    */}
                    <ButtonPrimary
                        href={loginUrl}
                        label={labelLogin}
                        disabled={error}
                    />
                    <span className="login-fetch-error">{errorMsg}</span>
                </div>
            </React.Fragment>
        );
    }
}

export default withTranslationsAsProps({
    'tripboards.invite.desc.logged.out': 'desc',
    'tripboards.invite.collaborators': 'title',
    'tripboards.invite.login': 'labelLogin',
    'tripboards.invite.signup': 'labelSignUp',
    'th.inbox.error.title': 'errorLogin'
})(InviteLogin);



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/invite-login.js